
(() => { if (window.BEAEPAGEJS === undefined) {
            window.BEAEPAGEJS = [];
          }

          if(window.beaePageSetting == undefined) {
            window.beaePageSetting = {};
          }
          
          window.beaePageSetting.pageId = "6748b2b58af814b0f3075152";
              window.beaePageSetting.pageTitle = "Contact me | Styngvi Designs"; 
              window.beaePageSetting.pageType = "page";

          let js_L4FU15KG = () => { let BeaeUseHooks = {};
      try {
        let argid = 'beae-i5w4bo3xsection-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-i5w4bo3x',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-i5w4bo3x');
        args.el = args.els[0];
        ((data) => { var t;if((t=data.el.querySelector(".beae-grid-system"))==null||t.addEventListener("scroll",o=>{var r,n;let a=o.target;if(!a.classList.contains("beae-grid-carousel"))return;let s=Math.round((a.scrollLeft+a.querySelector(".beae-grid-carousel__snaps").offsetLeft)/(a.offsetWidth*.8))+1;(r=data.el.querySelector(".beae-grid-carousel__pagination div.active"))==null||r.classList.remove("active"),(n=data.el.querySelector('.beae-grid-carousel__pagination div[data-index="'+s+'"]'))==null||n.classList.add("active")}),data.mode.value=="live"){const videoContainer=data.el.querySelector('.beae-section-background-video[data-device="desktop"]'),videoMobileContainer=data.el.querySelector('.beae-section-background-video[data-device="mobile"]'),initVideoBackground=[];if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection){if(window.innerWidth>=768){if(videoContainer){let options={};if(data.optionsVideo)try{eval("options = "+data.optionsVideo)}catch(o){options={},console.error(o)}const rs=window.BEAEVIDEO.convertBackgroundSection(options,videoContainer);rs&&(videoContainer.innerHTML=rs.html,initVideoBackground.push("desktop"))}}else if(videoMobileContainer){let options={};if(data.optionsVideoMobile)try{eval("options = "+data.optionsVideoMobile)}catch(o){options={},console.error(o)}const rs=window.BEAEVIDEO.convertBackgroundSection(options,videoMobileContainer);rs&&(videoMobileContainer.innerHTML=rs.html,initVideoBackground.push("mobile"))}}(videoContainer||videoMobileContainer)&&window.addEventListener("resize",()=>{if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection){if(!initVideoBackground.includes("desktop")&&window.innerWidth>=768&&videoContainer){const o=window.BEAEVIDEO.convertBackgroundSection(data.optionsVideo,videoContainer);o&&(videoContainer.innerHTML=o.html,initVideoBackground.push("desktop"))}if(!initVideoBackground.includes("mobile")&&window.innerWidth<768&&videoMobileContainer){const o=window.BEAEVIDEO.convertBackgroundSection(data.optionsVideoMobile,videoMobileContainer);o&&(videoMobileContainer.innerHTML=o.html,initVideoBackground.push("mobile"))}}})}data.el.querySelectorAll(".beae-text-highlight").forEach(o=>{new IntersectionObserver((s,r)=>{s.forEach(n=>{n.isIntersecting&&(n.target.querySelectorAll("path, line").forEach(l=>{l.style.strokeDasharray=parseFloat(l.getAttribute("data-dash-ratio")*n.target.offsetWidth*2)+"px, 999999px"}),r.unobserve(n.target))})},{root:document,rootMargin:"0px 0px -40%"}).observe(o)}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-i5w4bo3x: ', ex)
      };
    

      try {
        let argid = 'beae-m50cnxe1block-text-editor',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-m50cnxe1',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-m50cnxe1');
        args.el = args.els[0];
        ((O) => { const P=O==null?void 0:O.el.querySelector(".btn-action-les-more");let H=O==null?void 0:O.el.querySelector(".beae-less-more");if(H){let z=H==null?void 0:H.getAttribute("data-height");H.style.height=z,H.style.overflow="hidden"}if(P&&H){let z=H==null?void 0:H.getAttribute("data-height");const N=O==null?void 0:O.el.querySelector(".beae-x-text-editor .beae-text-content");let A=0;N==null||N.childNodes.forEach(I=>{I.nodeType===1&&(A+=I==null?void 0:I.offsetHeight)}),P.addEventListener("click",()=>{P.getAttribute("data-type")=="more"?(H.classList.remove("beae-show-more"),H.style.height=z,P.setAttribute("data-type","less"),P.style.setProperty("--beae-less-more-height",z),P.innerHTML=P.getAttribute("data-show-more-text")):(P.style.setProperty("--beae-less-more-height",A+"px"),H.classList.add("beae-show-more"),H.style.height="auto",P.setAttribute("data-type","more"),P.innerHTML=P.getAttribute("data-show-less-text"))})} })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-m50cnxe1: ', ex)
      };
    

      try {
        let argid = 'beae-w1wiaj3qblock-text-editor',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-w1wiaj3q',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-w1wiaj3q');
        args.el = args.els[0];
        ((O) => { const P=O==null?void 0:O.el.querySelector(".btn-action-les-more");let H=O==null?void 0:O.el.querySelector(".beae-less-more");if(H){let z=H==null?void 0:H.getAttribute("data-height");H.style.height=z,H.style.overflow="hidden"}if(P&&H){let z=H==null?void 0:H.getAttribute("data-height");const N=O==null?void 0:O.el.querySelector(".beae-x-text-editor .beae-text-content");let A=0;N==null||N.childNodes.forEach(I=>{I.nodeType===1&&(A+=I==null?void 0:I.offsetHeight)}),P.addEventListener("click",()=>{P.getAttribute("data-type")=="more"?(H.classList.remove("beae-show-more"),H.style.height=z,P.setAttribute("data-type","less"),P.style.setProperty("--beae-less-more-height",z),P.innerHTML=P.getAttribute("data-show-more-text")):(P.style.setProperty("--beae-less-more-height",A+"px"),H.classList.add("beae-show-more"),H.style.height="auto",P.setAttribute("data-type","more"),P.innerHTML=P.getAttribute("data-show-less-text"))})} })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-w1wiaj3q: ', ex)
      };
    

      try {
        let argid = 'beae-6vk54jbmblock-image',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-6vk54jbm',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-6vk54jbm');
        args.el = args.els[0];
        ((_) => { if(_.el){let w,k=_.autoHover;var b=_.el.querySelector(".beae-img-ratio-control"),v=_.el.querySelector(".beae-img-comp-container"),y=_.el.querySelector(".beae-img-comp-container--second");if(b&&y){let g=function(C){let x=0,L,S,$;B(),k?_.el.onmouseover=function(P){V(P)}:C.onmousedown=function(P){V(P)},_.el.onmouseup=function(){M()},C.ontouchstart=function(P){V(P)},_.el.ontouchend=function(){M()};function B(){new ResizeObserver(()=>{window.requestAnimationFrame(()=>{w=y.offsetWidth})}).observe(y),C.style.left&&(S=parseInt(C.style.left))}function V(P){check=!1,P.preventDefault(),P.clientX?L=P.clientX:L=P.touches[0].clientX,x=1,_.el.onmousemove=function(H){T(H)},_.el.ontouchmove=function(H){T(H)}}function M(){x=0,isNaN($)||(S=$),check=!0}function T(P){if(x==0||k&&!(P.target==y||P.target==_.el.querySelector(".beae-image-secondary")))return!1;$=E(P),$<0&&($=0),$>100&&($=100),O($)}function E(P){P=P.changedTouches?P.changedTouches[0]:P;let H;return k?H=Math.round(P.offsetX*100/w):H=Math.round(S-(L-P.pageX)*100/w),H}function O(P){C.style.left=P+"%",y.style.clipPath=`polygon(${P}% 0%, ${P}% 100%, 100% 100%, 100% 0)`,v.style.clipPath=`polygon(0% 100%, 0% 0%, ${P}% 0%, ${P}% 100%)`}};b&&y&&g(b),window.addEventListener("resize",function(){b&&y&&(new ResizeObserver(()=>{window.requestAnimationFrame(()=>{w=y.offsetWidth})}).observe(y),g(b))})}} })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-6vk54jbm: ', ex)
      };
    

      try {
        let argid = 'beae-odp7np2mblock-developer',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-odp7np2m',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-odp7np2m');
        args.el = args.els[0];
        ((data
) => { const fields = data.el.querySelectorAll('.beae-form-field');

if(fields && fields.length) { 
    fields.forEach(field => {
        const input = field.querySelector('input[type="text"], input[type="email"], textarea');
        if(input) {
            input.addEventListener('focus', function() {
                const fieldForcus = data.el.querySelector('.beae-form-field.focus');
                if(fieldForcus) {
                    fieldForcus.classList.remove('focus')
                }
                field.classList.add('focus');
            });
        }
    })
} })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-odp7np2m: ', ex)
      };
    

      try {
        let argid = 'beae-odp7np2mblock-form',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-odp7np2m',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-odp7np2m');
        args.el = args.els[0];
        ((f) => { const h=window.location.href.indexOf("contact_posted=true")!==-1,_=f.el.querySelector("form");f.el.querySelector(".beae-btn-pr");const b=f.el.querySelectorAll("input","select","button","textarea","checkbox","radio"),v=f.el.querySelector(".btn-lightbox-form > a");!h&&f.mode.value!=="builder"&&(f.el.querySelector(".beae-form-success-message").style="display: none"),h&&f.afterSubmitting=="redirect"&&f.redirect&&(window.location.href=f.redirect);const y=[];_&&_.addEventListener("submit",w=>{w.preventDefault();for(let k=0;k<b.length;k++)y.push({fieldKey:b[k].name,fieldType:b[k].type,fieldValue:b[k].value})}),v&&(v.onclick=()=>{const w=document.createElement("div");w.innerHTML=_.outerHTML||"",window.BeaePopupLibrary.createPopup(w,{layout:"center",layoutMobile:"bottom",width:"500px"})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-odp7np2m: ', ex)
      };
    }; if (window.BEAEBASE) {js_L4FU15KG()} else {window.BEAEPAGEJS.push(js_L4FU15KG)} })(); 